import { AccessGroup } from "./access-group";
import { AccessRight } from "./access-right";

export class AccessUser {
    ID: any ;
    Name: any;
    Type: any;
    IsAllowed: boolean;
    Priority: number ;
    MemberOfGroups: AccessGroup[] = [];
    AccessRights : AccessRight[] = [];
 }